import React from "react";

/* Palmetto-style illustrated cards — recolored to HMCD palette
   Colors used: green #2D7A4D, orange #E65100, blue #1E88E5, cream #FDFBF7, ink #0F172A
*/

export const IllusSolar = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#E6F4EA" />
    {/* Sun */}
    <circle cx="325" cy="70" r="34" fill="#FF9800" />
    <g stroke="#FF9800" strokeWidth="4" strokeLinecap="round">
      <line x1="325" y1="20" x2="325" y2="8" />
      <line x1="275" y1="70" x2="262" y2="70" />
      <line x1="290" y1="35" x2="280" y2="25" />
      <line x1="360" y1="35" x2="370" y2="25" />
      <line x1="360" y1="105" x2="370" y2="115" />
    </g>
    {/* House body */}
    <rect x="90" y="170" width="220" height="110" fill="#FDFBF7" stroke="#0F172A" strokeWidth="3" />
    {/* Roof */}
    <polygon points="80,170 200,80 320,170" fill="#0F172A" />
    {/* Solar panels */}
    <g transform="translate(140,110) rotate(-32)">
      <rect x="0" y="0" width="90" height="52" fill="#1E88E5" stroke="#0F172A" strokeWidth="2" />
      <line x1="30" y1="0" x2="30" y2="52" stroke="#0F172A" strokeWidth="1.2" />
      <line x1="60" y1="0" x2="60" y2="52" stroke="#0F172A" strokeWidth="1.2" />
      <line x1="0" y1="26" x2="90" y2="26" stroke="#0F172A" strokeWidth="1.2" />
    </g>
    {/* Door */}
    <rect x="180" y="220" width="40" height="60" fill="#2D7A4D" stroke="#0F172A" strokeWidth="2" />
    <circle cx="212" cy="252" r="1.8" fill="#FF9800" />
    {/* Window */}
    <rect x="115" y="200" width="40" height="40" fill="#e6f4ea" stroke="#0F172A" strokeWidth="2" />
    <rect x="245" y="200" width="40" height="40" fill="#e6f4ea" stroke="#0F172A" strokeWidth="2" />
    {/* Ground */}
    <line x1="20" y1="280" x2="380" y2="280" stroke="#0F172A" strokeWidth="3" />
  </svg>
);

export const IllusBattery = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#FFF3E0" />
    {/* House silhouette */}
    <polygon points="60,180 130,110 200,180" fill="#0F172A" opacity="0.15" />
    <rect x="60" y="180" width="140" height="90" fill="#0F172A" opacity="0.1" />
    {/* Battery unit */}
    <rect x="220" y="130" width="130" height="150" rx="8" fill="#FDFBF7" stroke="#0F172A" strokeWidth="3" />
    <rect x="235" y="115" width="20" height="20" rx="3" fill="#0F172A" />
    <rect x="315" y="115" width="20" height="20" rx="3" fill="#0F172A" />
    {/* Battery indicator */}
    <rect x="240" y="150" width="90" height="30" rx="4" fill="#e6f4ea" stroke="#2D7A4D" strokeWidth="2" />
    <rect x="245" y="155" width="55" height="20" rx="2" fill="#2D7A4D" />
    {/* Lightning bolt */}
    <path d="M285 200 L260 240 L280 240 L270 270 L305 225 L285 225 Z" fill="#FF9800" stroke="#0F172A" strokeWidth="2" strokeLinejoin="round" />
    <line x1="20" y1="280" x2="380" y2="280" stroke="#0F172A" strokeWidth="3" />
  </svg>
);

export const IllusHVAC = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#E3F2FD" />
    {/* House */}
    <rect x="70" y="170" width="200" height="110" fill="#FDFBF7" stroke="#0F172A" strokeWidth="3" />
    <polygon points="60,170 170,90 280,170" fill="#2D7A4D" />
    {/* HVAC unit */}
    <rect x="290" y="200" width="80" height="70" rx="4" fill="#FDFBF7" stroke="#0F172A" strokeWidth="3" />
    <circle cx="330" cy="235" r="22" fill="none" stroke="#0F172A" strokeWidth="2.5" />
    <g stroke="#1E88E5" strokeWidth="3" strokeLinecap="round">
      <line x1="330" y1="235" x2="345" y2="220" />
      <line x1="330" y1="235" x2="315" y2="220" />
      <line x1="330" y1="235" x2="345" y2="250" />
      <line x1="330" y1="235" x2="315" y2="250" />
    </g>
    {/* Cold air lines */}
    <g stroke="#1E88E5" strokeWidth="2.5" strokeLinecap="round" opacity="0.6">
      <path d="M270 210 Q 260 215 270 220" fill="none" />
      <path d="M270 230 Q 260 235 270 240" fill="none" />
      <path d="M270 250 Q 260 255 270 260" fill="none" />
    </g>
    {/* Door */}
    <rect x="150" y="220" width="40" height="60" fill="#FF9800" stroke="#0F172A" strokeWidth="2" />
    <line x1="20" y1="280" x2="380" y2="280" stroke="#0F172A" strokeWidth="3" />
  </svg>
);

export const IllusWater = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#E6F4EA" />
    {/* Shower head */}
    <rect x="180" y="60" width="40" height="10" rx="2" fill="#0F172A" />
    <rect x="195" y="70" width="10" height="30" fill="#0F172A" />
    <path d="M150 100 Q 200 90 250 100 L 240 130 Q 200 122 160 130 Z" fill="#0F172A" />
    {/* Water drops */}
    <g fill="#1E88E5">
      <path d="M170 140 Q 173 155 170 160 Q 167 155 170 140 Z" />
      <path d="M190 150 Q 193 168 190 175 Q 187 168 190 150 Z" />
      <path d="M210 145 Q 213 160 210 168 Q 207 160 210 145 Z" />
      <path d="M230 155 Q 233 172 230 180 Q 227 172 230 155 Z" />
    </g>
    {/* Water tank */}
    <rect x="80" y="150" width="70" height="130" rx="35" fill="#FDFBF7" stroke="#0F172A" strokeWidth="3" />
    <circle cx="115" cy="200" r="14" fill="#FF9800" />
    <path d="M115 194 L 111 202 L 115 208 L 119 202 Z" fill="#FDFBF7" />
    {/* Person head silhouette */}
    <circle cx="200" cy="210" r="28" fill="#FF9800" opacity="0.8" />
    <line x1="20" y1="280" x2="380" y2="280" stroke="#0F172A" strokeWidth="3" />
  </svg>
);

export const IllusITE = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#E6F4EA" />
    {/* Building wall cross-section */}
    <g transform="translate(60,50)">
      {/* Interior wall */}
      <rect x="0" y="0" width="40" height="200" fill="#FDFBF7" stroke="#0F172A" strokeWidth="2.5" />
      <text x="20" y="105" fontFamily="JetBrains Mono, monospace" fontSize="8" fill="#0F172A" textAnchor="middle" transform="rotate(-90 20 105)">MUR</text>
      {/* Insulation layer */}
      <rect x="40" y="0" width="55" height="200" fill="#FF9800" stroke="#0F172A" strokeWidth="2.5" />
      <g stroke="#0F172A" strokeWidth="1" opacity="0.4">
        <line x1="45" y1="0" x2="45" y2="200" />
        <line x1="55" y1="0" x2="55" y2="200" />
        <line x1="65" y1="0" x2="65" y2="200" />
        <line x1="75" y1="0" x2="75" y2="200" />
        <line x1="85" y1="0" x2="85" y2="200" />
      </g>
      <text x="67" y="105" fontFamily="JetBrains Mono, monospace" fontSize="8" fill="#0F172A" textAnchor="middle" transform="rotate(-90 67 105)">ISOLANT</text>
      {/* Finishing coat */}
      <rect x="95" y="0" width="12" height="200" fill="#2D7A4D" stroke="#0F172A" strokeWidth="2.5" />
    </g>
    {/* Heat arrows going out (before) */}
    <g stroke="#E65100" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.6">
      <path d="M180 100 Q 200 105 220 100" />
      <path d="M215 100 L 225 95 L 220 100 L 225 105 Z" fill="#E65100" />
      <path d="M180 150 Q 200 155 220 150" />
      <path d="M215 150 L 225 145 L 220 150 L 225 155 Z" fill="#E65100" />
    </g>
    {/* Home icon */}
    <g transform="translate(260,90)">
      <polygon points="30,0 60,25 60,60 0,60 0,25" fill="#FDFBF7" stroke="#0F172A" strokeWidth="2.5" />
      <rect x="22" y="35" width="16" height="25" fill="#2D7A4D" />
      {/* thermometer */}
      <circle cx="80" cy="30" r="10" fill="#1E88E5" />
      <rect x="77" y="12" width="6" height="20" rx="3" fill="#1E88E5" stroke="#0F172A" strokeWidth="1.5" />
      <text x="80" y="34" fontFamily="Fraunces, serif" fontSize="10" fill="#FDFBF7" textAnchor="middle" fontWeight="700">-5°</text>
    </g>
    <line x1="20" y1="260" x2="380" y2="260" stroke="#0F172A" strokeWidth="3" />
    <text x="200" y="285" fontFamily="JetBrains Mono, monospace" fontSize="9" fill="#0F172A" textAnchor="middle" letterSpacing="1">MUR + ISOLANT + FINITION</text>
  </svg>
);

export const IllusAppBills = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#FDF6E3" />
    {/* Phone */}
    <rect x="140" y="30" width="120" height="240" rx="16" fill="#0F172A" />
    <rect x="150" y="50" width="100" height="200" rx="4" fill="#FDFBF7" />
    {/* App content */}
    <rect x="160" y="62" width="80" height="10" rx="2" fill="#e6f4ea" />
    <text x="200" y="100" fontFamily="Fraunces, serif" fontSize="24" fontWeight="700" textAnchor="middle" fill="#0F172A">-38%</text>
    <rect x="160" y="115" width="80" height="6" rx="2" fill="#e2e8f0" />
    <rect x="160" y="115" width="60" height="6" rx="2" fill="#2D7A4D" />
    {/* Chart bars */}
    <g fill="#2D7A4D">
      <rect x="162" y="180" width="10" height="30" />
      <rect x="176" y="170" width="10" height="40" />
      <rect x="190" y="150" width="10" height="60" />
      <rect x="204" y="160" width="10" height="50" />
      <rect x="218" y="140" width="10" height="70" />
      <rect x="232" y="130" width="10" height="80" fill="#FF9800" />
    </g>
    <rect x="160" y="222" width="80" height="20" rx="10" fill="#FF9800" />
  </svg>
);

export const IllusRewards = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#E3F2FD" />
    {/* Phone */}
    <rect x="140" y="30" width="120" height="240" rx="16" fill="#0F172A" />
    <rect x="150" y="50" width="100" height="200" rx="4" fill="#FDFBF7" />
    {/* Star / trophy */}
    <polygon points="200,90 210,120 240,120 216,138 226,168 200,150 174,168 184,138 160,120 190,120" fill="#FF9800" stroke="#0F172A" strokeWidth="2" strokeLinejoin="round" />
    {/* Points */}
    <text x="200" y="200" fontFamily="Fraunces, serif" fontSize="20" fontWeight="700" textAnchor="middle" fill="#0F172A">+250 pts</text>
    <rect x="160" y="218" width="80" height="20" rx="10" fill="#2D7A4D" />
  </svg>
);

export const IllusTrack = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#F5F1EA" />
    <rect x="140" y="30" width="120" height="240" rx="16" fill="#0F172A" />
    <rect x="150" y="50" width="100" height="200" rx="4" fill="#FDFBF7" />
    {/* Circular gauge */}
    <circle cx="200" cy="140" r="40" fill="none" stroke="#e2e8f0" strokeWidth="8" />
    <circle cx="200" cy="140" r="40" fill="none" stroke="#2D7A4D" strokeWidth="8" strokeDasharray="180 260" strokeLinecap="round" transform="rotate(-90 200 140)" />
    <text x="200" y="146" fontFamily="Fraunces, serif" fontSize="18" fontWeight="700" textAnchor="middle" fill="#0F172A">72%</text>
    {/* Bars */}
    <rect x="162" y="200" width="76" height="6" rx="3" fill="#e2e8f0" />
    <rect x="162" y="200" width="50" height="6" rx="3" fill="#FF9800" />
    <rect x="162" y="215" width="76" height="6" rx="3" fill="#e2e8f0" />
    <rect x="162" y="215" width="35" height="6" rx="3" fill="#1E88E5" />
    <rect x="162" y="230" width="76" height="6" rx="3" fill="#e2e8f0" />
    <rect x="162" y="230" width="60" height="6" rx="3" fill="#2D7A4D" />
  </svg>
);

export const IllusDiscount = ({ className = "" }) => (
  <svg viewBox="0 0 400 300" className={className} xmlns="http://www.w3.org/2000/svg">
    <rect width="400" height="300" fill="#FFF3E0" />
    {/* Tag */}
    <g transform="translate(80,60) rotate(-8)">
      <path d="M0 0 L140 0 L180 50 L140 100 L0 100 Z" fill="#FF9800" stroke="#0F172A" strokeWidth="3" strokeLinejoin="round" />
      <circle cx="150" cy="50" r="8" fill="#FDFBF7" stroke="#0F172A" strokeWidth="2" />
      <text x="70" y="62" fontFamily="Fraunces, serif" fontSize="34" fontWeight="700" textAnchor="middle" fill="#0F172A">-30%</text>
    </g>
    {/* Small products */}
    <rect x="240" y="160" width="70" height="70" rx="8" fill="#FDFBF7" stroke="#0F172A" strokeWidth="2.5" />
    <rect x="255" y="180" width="40" height="8" rx="2" fill="#2D7A4D" />
    <rect x="255" y="195" width="30" height="8" rx="2" fill="#e6f4ea" />
    <rect x="255" y="210" width="40" height="8" rx="2" fill="#1E88E5" />
    <line x1="20" y1="280" x2="380" y2="280" stroke="#0F172A" strokeWidth="3" />
  </svg>
);
